const products = [
  {
    id: "baby-onesie",
    title: "Baby Onesie with Colorful Bear & Back QR Code",
    price: "$33.52",
    url: "https://reh-dogg-arcade.printify.me/product/29531096/baby-onesie-with-colorful-bear-and-amp-back-qr-code-cute-tech-baby-bodysuit",
    image: "/assets/products/baby-onesie.webp",
  },
  {
    id: "arcade-night-skater-skirt",
    title: "Arcade Night Women's Skater Skirt",
    price: "$43.99",
    url: "https://reh-dogg-arcade.printify.me/product/29530921/arcade-night-womens-skater-skirt-retro-gaming-and-amp-dog-graphic",
    image: "/assets/products/arcade-night-skater-skirt.webp",
  },
  {
    id: "retro-arcade-racerback-dress",
    title: "Retro Arcade Dog Racerback Dress",
    price: "$42.99",
    url: "https://reh-dogg-arcade.printify.me/product/29530610/retro-arcade-dog-racerback-dress-reh-dogg-arcade-all-over-print",
    image: "/assets/products/retro-arcade-racerback-dress.webp",
  },
  {
    id: "gold-dog-tag-necklace",
    title: "Gold Dog Tag Necklace with Fantasy Creature Design",
    price: "$34.95",
    url: "https://reh-dogg-arcade.printify.me/product/29530548/gold-dog-tag-necklace-with-colorful-fantasy-creature-design",
    image: "/assets/products/gold-dog-tag-necklace.webp",
  },
  {
    id: "retro-arcade-basketball-jersey",
    title: "Retro Arcade Dog Basketball Jersey",
    price: "$49.38",
    url: "https://reh-dogg-arcade.printify.me/product/29530516/retro-arcade-dog-basketball-jersey-rehdogg-arcade-all-over-print",
    image: "/assets/products/retro-arcade-basketball-jersey.webp",
  },
  {
    id: "reh-dogg-arcade-t-shirt",
    title: "Reh Dogg Arcade T-shirt",
    price: "$30.02",
    url: "https://reh-dogg-arcade.printify.me/product/29530423/reh-dogg-arcade-t-shirt-retro-arcade-dog-gamer-graphic-qr-code-back",
    image: "/assets/products/reh-dogg-arcade-t-shirt.webp",
  },
  {
    id: "arcade-pet-gamer-mug",
    title: "Arcade Pet Gamer Mug",
    price: "$11.99",
    url: "https://reh-dogg-arcade.printify.me/product/29530410/arcade-pet-gamer-mug-reh-dogg-arcade-retro-gaming-dog-design",
    image: "/assets/products/arcade-pet-gamer-mug.webp",
  },
  {
    id: "arcade-nights-basketball-shorts",
    title: "Arcade Nights Basketball Shorts",
    price: "$56.37",
    url: "https://reh-dogg-arcade.printify.me/product/29530402/arcade-nights-basketball-shorts-reh-dogg-arcade-graphic-aop",
    image: "/assets/products/arcade-nights-basketball-shorts.webp",
  },
  {
    id: "high-top-sneakers",
    title: "High Top Sneakers - Retro Neon Hip-Hop Collage Print",
    price: "$53.68",
    url: "https://reh-dogg-arcade.printify.me/product/29530398/high-top-sneakers-retro-neon-hip-hop-collage-print",
    image: "/assets/products/high-top-sneakers.webp",
  },
  {
    id: "arcade-dog-graphic-jersey",
    title: "Arcade Dog Graphic Jersey",
    price: "$42.93",
    url: "https://reh-dogg-arcade.printify.me/product/29530206/arcade-dog-graphic-jersey-reh-dogg-retro-gaming-tee",
    image: "/assets/products/arcade-dog-graphic-jersey.webp",
  },
  {
    id: "bear-galaxy-cap",
    title: "Bear Galaxy Cap",
    price: "Coming Soon",
    url: null,
    comingSoon: true,
    image: "/assets/products/bear-galaxy-cap.webp",
  },
  {
    id: "reh-dogg-arcade-hoodie",
    title: "Reh Dogg Arcade Hoodie",
    price: "Coming Soon",
    url: null,
    comingSoon: true,
    image: "/assets/products/reh-dogg-arcade-hoodie.webp",
  },
];

export default products;
